import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customBaseURL, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_BUSINESS, GET_BUSINESS_SUCCESS, GET_BUSINESS_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getBusiness({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/adib/admin/businesses`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParam,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: GET_BUSINESS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BUSINESS_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BUSINESS_ERROR, payload: error });
  }
}

export function* watchGetBusiness() {
  yield takeEvery(GET_BUSINESS, getBusiness);
}

function* getBusinessSaga() {
  yield all([fork(watchGetBusiness)]);
}

export default getBusinessSaga;
